import { css } from '@emotion/react';
type Props = { color?: string };
export default ({ color = 'var(--primary)' }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1898 12.906C10.5785 13.4262 11.0744 13.8566 11.6439 14.1681C12.2134 14.4795 12.8431 14.6647 13.4904 14.7111C14.1377 14.7575 14.7874 14.664 15.3954 14.437C16.0034 14.21 16.5555 13.8547 17.0143 13.3953L19.7296 10.6772C20.554 9.82282 21.0101 8.67851 20.9998 7.49073C20.9895 6.30296 20.5136 5.16675 19.6745 4.32684C18.8354 3.48692 17.7004 3.01049 16.5138 3.00017C15.3272 2.98985 14.184 3.44646 13.3305 4.27165L11.7737 5.82095M13.8102 11.094C13.4215 10.5738 12.9256 10.1434 12.3561 9.83195C11.7866 9.5205 11.1569 9.33529 10.5096 9.28889C9.86232 9.24248 9.21264 9.33597 8.60462 9.563C7.99661 9.79004 7.44449 10.1453 6.9857 10.6047L4.27037 13.3228C3.44601 14.1772 2.98986 15.3215 3.00017 16.5093C3.01048 17.697 3.48643 18.8332 4.3255 19.6732C5.16457 20.5131 6.29964 20.9895 7.48622 20.9998C8.6728 21.0101 9.81596 20.5535 10.6695 19.7283L12.2172 18.1791"
        stroke="#262626"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
